import { ThemeName, ThemeNames, isThemeName } from 'constantsValues/themeNames';

const resolveThemeName = (themeName?: string | null): ThemeName => {
	return isThemeName(themeName) ? themeName : ThemeNames.codan;
};

const getThemeBaseName = (themeName: ThemeName): string => {
	return themeName.replace(/-theme$/i, '');
};

export const getBrandFromTheme = (themeName?: string | null): string => {
	return getThemeBaseName(resolveThemeName(themeName));
};

const getTrackingSiteSlug = (themeName?: string | null): string => {
	const brandSlug = getThemeBaseName(resolveThemeName(themeName)).toLowerCase();
	return `mit${brandSlug}-erhverv`;
};

export const DownloadTracking = (
	category: string,
	documentType: string,
	fileDownloadType: 'preview' | 'download',
	themeName?: string | null
) => {
	const resolvedTheme = resolveThemeName(themeName);

	return {
		event: 'trackFileDownload',
		fileCategory: category,
		fileExtension: documentType,
		fileDownloadType: fileDownloadType,
		fileName: `virtualurl/business/customer/web/${getTrackingSiteSlug(resolvedTheme)}${window.location.pathname}`,
		linkUrl: window.location.href,
	};
};

export const InternalSearchTracking = (searchTerm: string, searchType: string, themeName?: string | null) => {
	return {
		event: 'trackSearch',
		searchTerm: searchTerm,
		searchType: searchType,
	};
};
